/**
 * `zam stats` — Learning dashboard.
 */

import { Command } from "commander";
import { getDomainCompetence, getUserStats } from "../../kernel/index.js";
import { resolveUser } from "../users/identity.js";
import { withDb } from "./shared/db.js";

export const statsCommand = new Command("stats")
  .description("Show learning dashboard for a user")
  .option("--user <id>", "User ID (default: whoami)")
  .option("--json", "Output as JSON")
  .action(async (opts) => {
    await withDb(async (db) => {
      const userId = await resolveUser(opts, db);
      const stats = await getUserStats(db, userId);
      const domains = await getDomainCompetence(db, userId);

      if (opts.json) {
        console.log(JSON.stringify({ stats, domains }, null, 2));
        return;
      }

      console.log(`Learning Dashboard — ${stats.userId}`);
      console.log("═".repeat(50));
      console.log(`  Total tokens:     ${stats.totalTokens}`);
      console.log(`  Cards in deck:    ${stats.cardsInDeck}`);
      console.log(`  Due today:        ${stats.dueToday}`);
      console.log(`  Blocked:          ${stats.blocked}`);
      console.log(`  Mature:           ${stats.mature}`);
      console.log(`  Avg stability:    ${stats.avgStability ?? "N/A"}`);
      console.log(`  Total sessions:   ${stats.totalSessions}`);
      console.log(`  Last session:     ${stats.lastSession ?? "N/A"}`);

      if (domains.length > 0) {
        console.log("\nDomain Competence:");
        console.log("─".repeat(80));
        console.log(
          "  Domain           Cards  Mature  Stability  Retention  Suggested Mode",
        );
        console.log(`  ${"─".repeat(74)}`);
        for (const d of domains) {
          console.log(
            `  ${d.domain.padEnd(17)} ${String(d.totalCards).padEnd(6)} ${String(d.matureCards).padEnd(7)} ${String(d.avgStability).padEnd(10)} ${(d.retentionRate * 100).toFixed(1).padStart(5)}%     ${d.suggestedMode}`,
          );
        }
      }
    });
  });
